import { exclude } from '@/lib/exclude';
import { getRequiredParams } from '@/router/utils/getRequiredParams';
import type { RouteLocationNamedRaw } from 'vue-router';

export type RedirectQuery = {
  params?: string;
  back: string;
} & Record<string, string>;

export function isRedirectQuery(query: Record<string, unknown>): query is RedirectQuery {
  return Boolean(query.back);
}

export async function routeFromRedirectQuery(redirectQuery: RedirectQuery): Promise<RouteLocationNamedRaw> {
  const { back: name } = redirectQuery;

  try {
    const params = redirectQuery.params ? JSON.parse(decodeURIComponent(redirectQuery.params as string)) : {};

    delete redirectQuery.params;

    const requiredParams = await getRequiredParams({ routeProperty: 'name', value: String(name) });
    if (requiredParams.some((param) => params[param] === undefined || params[param] === null)) {
      return { name: 'Launcher' };
    }

    // `userId` is used to force a logout when authenticated user's uid does not match it
    // It's handled inside the authentication.service
    return { name, params, query: exclude(redirectQuery, ['params', 'back', 'userId']) };
  }
  catch {
    return { name: 'Launcher' };
  }
}
